import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propFunc, propStr, propBool, } from '../../../../helpers/custom-prop-types';
import { isProffitSearchFreePlan, isProffitSearchTrialPlan, isProffitSearchStandardPlan, } from '../../../../helpers/profile';
import HtmlLink from '../../../Ui/Common/HtmlLink';
const ProffitSearchLandingPageCtaButton = (props) => {
    const { activatedText, className, isEndTrial, plan, showFormModal, standardText, trialText, } = props;
    const { onClick, text, to } = useMemo(() => {
        // ゲスト、もしくはProffit Search未登録のユーザーの場合
        let obj = {
            onClick: showFormModal,
            text: trialText,
            to: '',
        };
        // フリープランのユーザーの場合
        if (isProffitSearchFreePlan(plan)) {
            obj = {
                onClick: isEndTrial ? undefined : showFormModal,
                text: isEndTrial ? standardText : trialText,
                to: '/proffit_search/account_plan',
            };
        }
        // トライアルプランのユーザー場合
        if (isProffitSearchTrialPlan(plan)) {
            obj = {
                text: standardText,
                to: '/proffit_search/account_plan',
            };
        }
        // スタンダードプランのユーザーの場合
        if (isProffitSearchStandardPlan(plan)) {
            obj = {
                text: activatedText,
                to: '/proffit_search',
            };
        }
        return obj;
    }, [activatedText, isEndTrial, plan, showFormModal, standardText, trialText]);
    return (_jsx(HtmlLink, Object.assign({ className: clsx('proffit_search_landing_page_cta_button button primary', className), isNoLinkComponent: onClick ? 'button' : undefined, onClick: onClick, to: to }, { children: text })));
};
ProffitSearchLandingPageCtaButton.propTypes = {
    activatedText: propStr(),
    className: propStr(),
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    showFormModal: propFunc().isRequired,
    standardText: propStr(),
    trialText: propStr(),
};
ProffitSearchLandingPageCtaButton.defaultProps = {
    activatedText: '早速スライドを探す',
    className: '',
    plan: undefined,
    standardText: 'スタンダードプランを申込む',
    trialText: 'まずは無料で使ってみる',
};
export default ProffitSearchLandingPageCtaButton;
